import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/store.ts";

import axios from 'axios';
import Swal from "sweetalert2";
type Appt = {
    id: string;
    kunde: string;
    start: string;
    slutt: string;
    type: "Chat" | "Samtale" | "Video";
    status: "Planlagt" | "Fullført" | "Avlyst" | "Completed" | "Cancelled" | "In-progres";
    belop: number;
    eventKey: string;
    slot_id: string;
    cancelled_by: string;
};
type appointmentProps = {
    newName: string,
    setNewName: (tab: string) => void,
    newType: string,
    setNewType: React.Dispatch<React.SetStateAction<"Chat" | "Samtale" | "Video">>,
    newStart: string,
    setNewStart: (tab: string) => void,
    pricingMode: string,
    consultDuration: number,
    slotMinutes: number,
    consultPrice: any,
    minutePrice: any,
    addAppt: any,
    NOK: (n: number) => string,
    appts: Appt[],
    setAppts: React.Dispatch<React.SetStateAction<Appt[]>>,
    currentUser: any,
    baseUrl: string,
};

export default function Appointments({ newName, setNewName, newType, setNewType, newStart, setNewStart, pricingMode, consultDuration, slotMinutes, consultPrice, minutePrice, addAppt, NOK, appts, setAppts, currentUser, baseUrl }: appointmentProps) {
    const [loading, setLoading] = useState(true);
    const client = useSelector((state: RootState) => state.client.client);
    const [filter, setFilter] = useState("today");
    const client_uid = client.uid || "clnt_QI9Jd1m0"; // fallback to default if not available
    const fetchAppointments = async (filter: string) => {
        try {
            const res = await axios.get(baseUrl + "/getAgentAppointmentsByFilter", {
                params: { token: currentUser.token, client_uid: client_uid, filter: filter },
            })

            console.log(res.data.data);
            setAppts(res.data.data);
        } catch (err) {
            console.error("Error fetching agent:", err);
        } finally {
            setLoading(false);

        }
    }
    useEffect(() => {
        fetchAppointments(filter);
    }, [currentUser?.token, baseUrl])
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                    <p className="mt-3 text-gray-600 animate-pulse">Laster inn avtaler...</p>
                </div>
            </div>
        );
    }

    const handleFilterChange = (filter: string) => {
        setFilter(filter);
        setLoading(true);
        fetchAppointments(filter);
    }

    const handleJoinClick = (eventKey: string) => {
        window.location.href = window.location.origin + '/agent/join-booking-call/' + eventKey
    }
    const handleCancelClick = async (id: string) => {
        const result = await Swal.fire({
            title: "Kanseller konsultasjon",
            html: `
                        <h3 style="margin-bottom: 2rem !important">Er du sikker på at du vil avbestille denne konsultasjonen?</h3>
                        <div style="text-align: left; margin: 0 0 16px; padding: 12px 14px; border-radius: 12px; border: 1px solid #e5e7eb; background: #f9fafb; font-size: 14px; color: #111827;">
                            <strong>Merk:</strong> Når en agent kansellerer en konsultasjon, blir hele det autoriserte beløpet frigitt tilbake til kunden umiddelbart.
                        </div>
                    `,
            showCancelButton: true,
            confirmButtonText: "Kanseller konsultasjon",
            cancelButtonText: "Close",
            customClass: {
                confirmButton: "swal-confirm-btn",
                cancelButton: "swal-cancel-btn",
            },
        });
        if (result.isConfirmed) {
            try {
                setLoading(true);
                let formData = new FormData();
                formData.append("token", currentUser.token);
                formData.append("id", id);
                const response = await axios.post(baseUrl + '/deleteSlot', formData);
                if (response.data.status === "OK") {
                    Swal.fire({
                        title: 'Success',
                        text: response.data.data,
                        icon: 'success',
                        timer: 1500,
                    })
                    fetchAppointments(filter);
                } else {
                    Swal.fire({
                        title: response.data.status,
                        text: response.data.data,
                        icon: 'error',
                        showConfirmButton: true,
                    })
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
    }
    return (
        <>
            <h3 className="font-bold text-purple-900 mb-2">Dine avtaler</h3>

            {/* Ny avtale */}
            <div className="mb-4 rounded-xl border p-3 bg-purple-50/40">
                <div className="grid md:grid-cols-5 gap-2 text-sm items-end">
                    <div>
                        <label className="block text-xs text-gray-600">Kunde</label>
                        <input value={newName} onChange={e => setNewName(e.target.value)} className="w-full rounded-lg border px-2 py-1" placeholder="Navn" />
                    </div>
                    <div>
                        <label className="block text-xs text-gray-600">Start</label>
                        <input type="datetime-local" value={newStart} onChange={e => setNewStart(e.target.value)} className="w-full rounded-lg border px-2 py-1" />
                    </div>
                    <div>
                        <label className="block text-xs text-gray-600">Type</label>
                        <select value={newType} onChange={e => setNewType(e.target.value as any)} className="w-full rounded-lg border px-2 py-1">
                            <option>Chat</option>
                            <option>Samtale</option>
                            <option>Video</option>
                        </select>
                    </div>
                    <div className="text-gray-700">
                        <div className="text-xs">Varighet</div>
                        <div className="font-semibold">{pricingMode === 'per_consult' ? consultDuration : slotMinutes} min</div>
                        <div className="text-[11px] text-gray-500">Pris: {pricingMode === 'per_consult' ? NOK(consultPrice) : NOK(minutePrice)}{pricingMode === 'per_min' && '/min'}</div>
                    </div>
                    <div className="text-right">
                        <button onClick={addAppt} className="rounded-full bg-purple-600 text-white px-4 py-2">Opprett</button>
                    </div>
                </div>
            </div>

            <div className="overflow-x-auto">
                <div className="flex gap-2 ml-auto justify-self-end">
                    <button
                        onClick={() => handleFilterChange('today')}
                        className={`rounded-full px-4 py-2 border ${filter === "today" ? "bg-purple-600 text-white border-purple-600" : ""
                            }`}
                    >
                        Today
                    </button>

                    <button
                        onClick={() => handleFilterChange("week")}
                        className={`rounded-full px-4 py-2 border ${filter === "week" ? "bg-purple-600 text-white border-purple-600" : ""
                            }`}
                    >
                        Week
                    </button>

                    <button
                        onClick={() => handleFilterChange("month")}
                        className={`rounded-full px-4 py-2 border ${filter === "month" ? "bg-purple-600 text-white border-purple-600" : ""
                            }`}
                    >
                        Month
                    </button>
                </div>
                <table className="min-w-full text-sm">
                    <thead>
                        <tr className="text-left text-gray-600">
                            <th className="p-2">Kunde</th>
                            <th className="p-2">Start</th>
                            <th className="p-2">Slutt</th>
                            <th className="p-2">Type</th>
                            <th className="p-2">Status</th>
                            <th className="p-2">Beløp</th>
                            <th className="p-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {appts.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={7}>No appointments found</td>
                            </tr>
                        )}
                        {appts.map(a => (
                            <tr key={a.id} className="border-t">
                                <td className="p-2">{a.kunde}</td>
                                <td className="p-2">{a.start?.replace("T", " ")}</td>
                                <td className="p-2">{a.slutt?.replace("T", " ")}</td>
                                <td className="p-2">{a.type}</td>
                                <td className={a.status === "Cancelled" ? "p-2 text-red-600" : a.status === "Completed" ? "p-2 text-green-600" : "p-2"}>{a.status === "Cancelled" ? a.status + " (" + a.cancelled_by + ")" : a.status}</td>
                                <td className="p-2">{NOK(a.belop)}</td>
                                <td className="p-2 text-right">
                                    <div className="flex gap-2 justify-end">
                                        {a.status !== "Completed" && a.status !== "Cancelled" && a.eventKey && (
                                            <button onClick={() => handleJoinClick(a.eventKey)} className="text-green-700 hover:underline">Join</button>
                                        )}
                                        {a.status !== "Completed" && a.status !== "In-progres" && a.status !== "Cancelled" && (


                                            <button onClick={() => handleCancelClick(a.slot_id)} className="text-red-600 hover:underline">Cancel</button>

                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}